// extracted by mini-css-extract-plugin
module.exports = {"main-component":"addTaskCheckBox_main-component__1nSgK"};